// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-41d7f914]{margin-bottom:10px}[data-v-41d7f914] .labeled-select{height:auto}", ""]);
// Exports
module.exports = exports;
